// extracted by mini-css-extract-plugin
export default {"form":"Map-Season_form__0iIJA","formFooter":"Map-Season_formFooter__ohTwU"};